import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["show", "visible", "showMask", "mask", "showClose", "closable", "getContainer", "container"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Drawer from './Drawer';

var DrawerWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(DrawerWrapper, _React$Component);

  var _super = _createSuper(DrawerWrapper);

  function DrawerWrapper(props) {
    _classCallCheck(this, DrawerWrapper);

    return _super.call(this, props);
  }

  _createClass(DrawerWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          visible = _this$props.visible,
          showMask = _this$props.showMask,
          mask = _this$props.mask,
          showClose = _this$props.showClose,
          closable = _this$props.closable,
          getContainer = _this$props.getContainer,
          container = _this$props.container,
          others = _objectWithoutProperties(_this$props, _excluded);

      var extral = {
        show: visible ? visible : show,
        showMask: mask ? mask : showMask,
        showClose: closable ? closable : showClose,
        container: getContainer ? getContainer : container
      };
      return /*#__PURE__*/React.createElement(Drawer, _extends({}, extral, others));
    }
  }]);

  return DrawerWrapper;
}(React.Component);

export default DrawerWrapper;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-drawer/src/index.js